import { render, staticRenderFns } from "./RatingSurvey.vue?vue&type=template&id=0dacc5ce&lang=html&"
import script from "./RatingSurvey.vue?vue&type=script&lang=js&"
export * from "./RatingSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports